import styled from "styled-components";
import { MainCorrect, MainFrame, MainFrameWrapper, MainHeadingColor, MainSection } from "../../../components/01_config/MainStyles";
import { sizes } from "../../../components/01_config/Sizes";
import { colors } from "../../../components/01_config/Colors";

const Wrapper = styled.div`
    margin-top: ${sizes.headerheight};
`

const Header = styled.div`
    position: relative;
    padding: 50px;
    background-color: ${colors.reading};
    color: white;
    font-size: 3rem;
    font-weight: bold;
    text-transform: uppercase;
    @media(max-width: 800px) {
        padding: 30px 0;
        text-align: center;
        font-size: 2rem
    }
`

const TextsSection = styled(MainSection)`
    flex-direction: column;
    scroll-margin-top: ${sizes.headerheight};
`

const HeadingColor = styled(MainHeadingColor)`
    text-align: center;
`


const FrameWrapper = styled(MainFrameWrapper)`
    gap: 50px;
    margin: 0 150px;
    @media(max-width: 800px) {
        margin: 0;
    }
`

const Frame = styled(MainFrame)`
    position: relative;
    max-width: 300px;
    padding: 0;
    padding-bottom: 15px;
    display: flex;
    flex-direction: column;
    height: fit-content;
    text-align: center;

`

const SignImage = styled.img`
    position: relative;
    width: 100%;
    object-fit: cover;
    margin: 0;
`

const Caption = styled(MainCorrect)`
`

export { Wrapper, Header, TextsSection, HeadingColor, FrameWrapper, Frame, SignImage, Caption }